/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Errors_Too_Many_RequestsInputs */

const en_us2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many error reports were sent. Wait a few minutes.`)
};

const pt_br2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foram enviados relatórios de erro demais. Espere alguns minutos.`)
};

const es_419_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se enviaron demasiados informes de error. Espera unos minutos.`)
};

const pt_pt2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foram enviados demasiados relatórios de erro. Espera alguns minutos.`)
};

const fr_fr2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de rapports d'erreur ont été envoyés. Attends quelques minutes.`)
};

const de_de2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden zu viele Fehlerberichte gesendet. Warte ein paar Minuten.`)
};

const it_it2_client_errors_too_many_requests = /** @type {(inputs: Client_Errors_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono stati inviati troppi report di errore. Attendi qualche minuto.`)
};

/**
* | output |
* | --- |
* | "Too many error reports were sent. Wait a few minutes." |
*
* @param {Client_Errors_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const client_errors_too_many_requests = /** @type {((inputs?: Client_Errors_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Errors_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_client_errors_too_many_requests(inputs)
	if (locale === "es-419") return es_419_client_errors_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_client_errors_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_client_errors_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_client_errors_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_client_errors_too_many_requests(inputs)
	return en_us2_client_errors_too_many_requests(inputs)
});
export { client_errors_too_many_requests as "client_errors.too_many_requests" }